import groupBy from 'lodash/groupBy'
import uniq from 'lodash/uniq'
import { createReducer } from 'src/utils/reducer'

const UPDATE_DASHBOARD_ACTION = 'UPDATE_DASHBOARD_ACTION'
const REMOVE_DASHBOARD_ACTION = 'REMOVE_DASHBOARD_ACTION'

export default createReducer(
    {
        runbookActions: {
            byId: {},
            ids: [],
        },
        userRunbooks: [],
    },
    {
        // [GET_DASHBOARD_STATS_RECEIVED]: (state, action) => {
        //     const byId = {}, ids = []
        //     for (let i = 0; i < action.data.actions.length; i++) {
        //         let item = action.data.actions[i]
        //         byId[item.id] = item
        //         ids.push(item.id)
        //     }
        //     return {
        //         ...state,
        //         runbookActions: {
        //             byId, ids,
        //         },
        //         userRunbooks: action.data.runbooks,
        //     }
        // },
        [UPDATE_DASHBOARD_ACTION]: (state, action) => {
            const { byId, ids } = state.runbookActions
            return {
                ...state,
                runbookActions: {
                    byId: {
                        ...byId,
                        [action.actionId]: {
                            ...(byId[action.actionId] || {}),
                            ...action.data,
                        },
                    },
                    ids: uniq([...ids, action.actionId]),
                },
            }
        },
        [REMOVE_DASHBOARD_ACTION]: (state, action) => {
            const { byId, ids } = state.runbookActions
            delete byId[action.actionId]
            return {
                ...state,
                runbookActions: {
                    byId: { ...byId },
                    ids: ids.filter((id) => id !== action.actionId),
                },
            }
        },
    }
)

const getParent = (ids, byId, id) => {
    for (let key of ids) {
        if (
            byId[key].children.indexOf(byId[id].uid) > -1 &&
            byId[key].runbook === byId[id].runbook
        ) {
            return byId[key].id
        }
    }
    return null
}

export const groupByParent = (ids, byId) => {
    const result = {}
    for (let key of ids) {
        let parent = getParent(ids, byId, key)
        if (result[parent]) {
            result[parent].push(key)
        } else {
            result[parent] = [key]
        }
    }
    return result
}

export const groupRunbookActions = (userId, runbookActions) => {
    const { ids, byId } = runbookActions
    const userActions = ids.filter((id) => byId[id].ownerUser === userId)
    const groupActions = groupBy(
        ids.filter((id) => userActions.indexOf(id) < 0),
        (id) => byId[id].ownerTeam
    )
    return {
        userActions,
        groupActions,
        byId,
    }
}

export const updateDashboardAction = (actionId, data) => (
    dispatch,
    getState
) => {
    const state = getState()
    const { userId, teams } = state.ui.app
    const isOwner = data.ownerUser === userId
    const isTeamOwner = teams.indexOf(data.ownerTeam) > -1
    if (data.status !== 1 || (!isOwner && !isTeamOwner)) {
        dispatch({
            type: REMOVE_DASHBOARD_ACTION,
            actionId,
        })
        return
    }
    dispatch({
        type: UPDATE_DASHBOARD_ACTION,
        actionId,
        data,
    })
}
